// extracted by mini-css-extract-plugin
module.exports = {"layoutContainer":"styles_layoutContainer__5L4bW","layoutContentWrp":"styles_layoutContentWrp__904T0"};